interface LogicBuilderSearchParams {
    customFlowSystemId?: string;
    publicServerDomain?: string;
    widgetId?: string;
}
export const getGlobalConfigFromParams = (isNonprod: boolean): LogicBuilderSearchParams | undefined => {
    if (!isNonprod) return undefined;
    const searchParams = new URLSearchParams(window.location.search);

    const customFlowSystemId = searchParams.get("customFlowSystemId") ?? undefined;
    const publicServerDomain = searchParams.get("publicServerDomain") ?? undefined;
    const widgetId = searchParams.get("widgetId") ?? undefined;

    return {
        customFlowSystemId,
        publicServerDomain,
        widgetId,
    };
};
